import React, { Component } from 'react';
import Row from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import { Banner } from '../../shared';
import './Services.scss';

class Services extends  Component {
    constructor(props) {
        super(props);
        this.state = {};
        window.scrollTo(0,0)

    }
    onClickServices(id) {
        let ele = document.getElementById(id);
        if( ele) {
            let offsetTop = ele.offsetTop;
            window.scrollTo(0,offsetTop- 15);

        }
    }

  render() {
    return (
    <>
      <Banner data = {{image: '/images/bob-banner.jpg', text: 'Our Services'}}/>
      <div className ="section our-services">
            <div className ="container">
                
                <Row className ="text-center"> 
                    <b>We offer a wide range of services, click on a service to see more info</b>
                </Row>
                <Hidden xsDown>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>

                    <Row container className ="button-list" direction="row"  justify="center" alignItems="center" spacing = {1}>
                        <Row item sm = { 6 } md = { 3 } > <Button variant="contained" color="primary" onClick ={ ()=> this.onClickServices('panel-1')}> <Typography variant="inherit" noWrap>Oil Changes </Typography></Button></Row>
                        
                        <Row item sm = { 6 } md = { 3 } > <Button variant="contained" color="primary" onClick ={ ()=> this.onClickServices('panel-4')}><Typography variant="inherit" noWrap> General Repairs</Typography></Button></Row>
                        <Row item sm = { 6 } md = { 3 } > <Button variant="contained" color="primary" onClick ={ ()=> this.onClickServices('panel-5')}><Typography variant="inherit" noWrap> Alignment </Typography></Button></Row>
                        <Row item sm = { 6 } md = { 3 } > <Button variant="contained" color="primary" onClick ={ ()=> this.onClickServices('panel-6')}><Typography variant="inherit" noWrap> OBD Diagnostics </Typography></Button></Row>
                    </Row>
                </Hidden>

                <div>&nbsp;</div>
                <div>&nbsp;</div>

                <ExpansionPanel id= "panel-1">
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                        <Typography > Oil Changes </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <div>
                            <Typography variant="h3" className ="heading"> When are you supposed to change your oil? </Typography>
                             
                                <p> This is a complicated question. It depends on what type of car you drive, how you drive it and in what climate you're driving it in!</p>
                                <p>Vehicles pre 2000 oil change specifications are one year or 12,000km unless you are considered a severe driver. </p>
                                <p>Under severe driving conditions, your oil change interval should be 3 months or 5,000km.</p>
                                <h3 className="MuiTypography-root heading MuiTypography-h3"> What is a severe driver? </h3>
                                <p>A severe driver is one who would operate their vehicle under these conditions:</p>
                                <ul className="list-view list-style-none">

                               

                                <li>Short trip operation in freezing temperatures </li>
                                <li>Extensive idling, example; cab or delivery service</li>
                                <li>Excessive towing</li>
                                <li>Excessive dusty road conditions</li>
                                </ul>
                                <p>So these vehicles need to have their oil changed in the spring, May/June and would not need another oil change until freezing temperatures, Nov/Dec unless more than 12,000 km have been accumulated in that time span. After the end of the year oil change, the oil should be changed three months later unless more than 5,000 km have been accumulated in that time period, because of “short trip operation in freezing temperatures. So the third oil change should be done in Feb/Mar. If one desires to take a risk, they could eliminate the third or “middle of winter” oil change, but remember to lengthen the summer interval and shorten the winter interval. Post-2000 vehicles are equipped with more and more oil controlled components; oil controlled timing chain tensioners, VVT Variable Valve Timing actuators and solenoids, DOD Displacement on Demand or cylinder deactivation, GDI Gasoline Direct Injection and Turbocharging systems. Clean and proper proprietary rating oils are crucial for the life expectancy of these expensive components. Most of these engines now require specific full synthetic oils, recommended from the manufactures. With these engines; the summer oil change intervals should be dropped from 12,000km to 8,000km and the “middle winter” or 5,000 km /3-month oil change interval should never be neglected. Always check the owner’s manual for manufacture recommended oil change intervals and specific proprietary oil ratings. However, if specifications seem drastic like 15,000-30,000km intervals remember oil changes are cheaper than these component replacements. Manufactures are extending oil change intervals for carbon credits. Finally, our current top oil specification is ILSAC GF-5 with ILSAC GF-6 entering the market next year combining 0w20, 5w20, and 5w30 into one blend and 0w16 into another. It is not clear yet if ILSAC GF-6 will meet all the requirements for just grades or for all manufactures' proprietary ratings as well.</p>
                                <h3 className="MuiTypography-root heading MuiTypography-h3"> Oil Change: </h3>
                                <p>
                                    Bringing vehicle into bay using sight sound and smell for inspection.
                                    <br/>Drain oil and filter change.
                                    <br/><br/>
                                    <b>Visually inspect undercarriage:</b>
                                </p>
                                <ul className="list-view  list-style-none">
                                    <li>Fluid leaks: further inspection needed with possible extra charge if any leaks are noticed</li>
                                    <li>Visually and physically inspect for damaged components of front end by shaking wheels (lubricate when applicable):</li>
                                    <li>Inner tie rod ends</li>
                                    <li>Outer tie rod ends</li>
                                    <li>Upper ball joints</li>
                                    <li>Lower ball joints</li>
                                    <li>Control arms and bushings</li>
                                    <li>Wheel bearings</li>
                                    <li>Struts and strut mounts</li>
                                    <li> Sway bar links and bushings</li>
                                    <li> Drive axles and boots</li>
                                    <li> Visually inspect exhaust systems</li>
                                    <li> Rear suspension components</li>
                                    <li> Look at disc brakes only for signs of wear (wheels need to be removed for proper inspection)</li>
                                    <li> Tire condition and pressures</li>
                                    <li> Lower vehicle and fill oil</li>
                                    <li> Visually inspect under hood</li>
                                    <li> Check fluid levels</li>
                                    <li> Brake fluid</li>
                                    <li> Power steering fluid when applicable</li>
                                    <li> Transmission</li>
                                    <li> Differential and transfer case when applicable</li>
                                    <li> Coolant system and check coolant condition in fall service</li>
                                    <li> We do not check or top up windshield washer fluid</li>
                                    <li> Check air filter</li>
                                    <li> Check cabin filter in spring service</li>
                                    <li> Check belts</li>
                                    <li> Checking cooling hoses for condition and leaks</li>
                                    <li> Check battery terminals for corrosion and clean if needed</li>
                                    <li> Lubricate all latches and hinges</li>
                                    <li> Reset oil light monitor</li>
                                </ul>
                                </div>
                        
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel id= "panel-4">
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4-content" id="panel4-header">
                        <Typography > General Repairs </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                    <div>
                        <p><b>We offer a large list of services at our shop.  Below are some of the services we offer.</b></p>
                        <ul className="list-view">
                            <li>ABS and Brakes</li>
                            <li>Supplemental restraint system repairs (SRS or airbags)</li>
                            <li>Electrical diagnostics and repair</li>
                            <li>Cooling system diagnostic and repair (Head gaskets, Water pumps, Heater cores etc...)</li>
                            <li>Engine repairs (Timing belt/chains, Oil leaks, RE and RE components and assemblies etc...)</li>
                            <li>Tune-ups, Drivability concerns, and Malfunction Indicator Light (MIL) Diagnostics</li>
                            <li>Hydraulic brake and fuel line repair</li>
                            <li>Battery, alternator, and starter diagnostics and repair</li>
                            <li>Suspension</li>
                        </ul>
                        <p><b> Our menu items are as follows </b></p>
                        <ul className="list-view">
                            <li> Safety Inspections </li>
                            <li> Oil changes</li>
                            <li> Coolant flush</li>
                            <li> Transmission service</li>
                            <li> Brake service</li>
                            <li> Complete crankcase clean</li>
                            <li> Engine de-carbon</li>
                            <li> Injector flush </li>
                            <li> 4x4 Service (drain and refill transfer case and differentials)</li>
                            <li> Alignments</li>
                            <li> Winter/Summer tire on rim Installation</li>
                            <li> 4 Wheel balance  </li>
                            <li> Tire repair</li>
                            <li> Tire Installation </li>
                        </ul>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel id= "panel-5">
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5-content" id="panel5-header">
                        <Typography > Alignment </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <div>
                        <p>Alignments are important to keep your vehicle driving true down the road and making sure your tires are wearing properly.</p>
                        <b>Vehicles that are misaligned could...</b>
                        <ul className="list-view">
                        <li>consistently pull to one side of the road</li>
                        <li>cause premature tire failure due to uneven wear</li>
                        <li>cause the steering wheel to be off center</li>
                        </ul>
                        <p>If you need an alignment feel free to call us and book an appointment <b>705-743-8800</b></p>
                        <p>Camber and Caster adjustments may cost extra depending on the vehicle's specifications.</p>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>


                <ExpansionPanel id= "panel-6">
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6-content" id="panel6-header">
                        <Typography > OBD Diagnostics </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                    <div aria-labelledby="panel6-header" id="panel6-content" role="region">
                        <div className="MuiExpansionPanelDetails-root">
                        <div>
                            <p>If your check engine light (or MIL) is on, then your car has an emission problem. We have the tools to perform generic diagnostics on all makes and models, OBD II and OBD I systems. We have been trained on and have purchased certain factory scan tools so that we can do more in-depth diagnostics and module reprogramming for the newer vehicles.</p>
                            <b>Currently we have...</b>
                            <ul className="list-view">
                            <li>Volkswagen/Audi</li>
                            <li>Toyota</li>
                            <li>Honda</li>
                            <li>Kia/Hyundai</li>
                            <li>CarDAQ J2534 Generic reprogramming scan tool (GM, Chrysler, Ford, Mazda, Nissan)</li>
                            </ul>
                            <p>These scan tools give us the ability to do important PCM updates to your vehicles from factory OEM websites as well as service your newer vehicles.</p>
                            <p><b> Give us a call to book an appointment 705-743-8800</b></p>
                            </div>
                        </div>
                        </div>

                    </ExpansionPanelDetails>
                </ExpansionPanel>

        
            </div>
      </div>
    </>)
  }
}

export default Services;
